module.exports = __webpack_public_path__ + "static/media/wall_parallax.5f7d6b7b.jpg";